/**
 * @GENERATED from Figma node 3638:52294
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const CodeDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#978F86"
      d="M6.539 6.184 1 12l5.539 5.816 1.432-1.322L3.69 12l4.28-4.494zM17.461 6.184 16.03 7.506 20.31 12l-4.28 4.494 1.432 1.322L23 12zM12.844 3.406 8.915 20.16l1.914.435L14.757 3.84z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(CodeDark);
export { ForwardRef as CodeDark };
